import { events } from '../core/events.js';
import { allPartsCollected } from './commParts.js';

// Communicator state. Starts broken — the device exists but only shows static.
// Collecting all communicator parts makes `canRepair()` true; once repaired,
// the device comes online and is ready for real transmissions.
//
// Events emitted:
//   'communicator:opened'
//   'communicator:closed'
//   'communicator:ready'      — all parts collected, waiting on player input
//   'communicator:repaired'
const state = {
  broken: true,
  open: false,
};

export function isBroken() { return state.broken; }
export function isOpen()   { return state.open; }
export function canRepair() { return state.broken && allPartsCollected(); }

export function setOpen(value) {
  if (state.open === value) return;
  state.open = value;
  events.emit(value ? 'communicator:opened' : 'communicator:closed');
}

export function repair() {
  if (!state.broken) return;
  state.broken = false;
  events.emit('communicator:repaired');
}

export function tryRepair() {
  if (!canRepair()) return false;
  repair();
  return true;
}

// Re-broadcast "ready" whenever a part is added and we're still broken — the
// UI listens to this to update its state. Hooked up in main once modules load.
events.on('inventory:added', () => {
  if (state.broken && allPartsCollected()) {
    events.emit('communicator:ready');
  }
});
